import { WHATSAPP_URL } from '../components/WhatsAppIcon';

/** Abre el chat de VCARS con el mensaje ya escrito (el cliente solo toca "Enviar"). */
export function whatsappMessageUrl(text: string): string {
  return `${WHATSAPP_URL}?text=${encodeURIComponent(text)}`;
}
